var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};

// src/hooks/usePropReaction.ts
import { observable, reaction, runInAction } from "mobx";
import { useLocalObservable } from "mobx-react";
import { useEffect, useRef, useState } from "react";
function usePropReaction(callback, props) {
  const [annotations] = useState(
    () => Object.keys(props).reduce((acc, key) => {
      acc[key] = observable.ref;
      return acc;
    }, {})
  );
  const previousValues = useRef(__spreadValues({}, props));
  const newValues = useLocalObservable(
    () => __spreadValues({}, props),
    annotations
  );
  runInAction(() => {
    Object.entries(props).forEach(([key, value]) => {
      if (value !== previousValues.current[key]) {
        newValues[key] = value;
      }
    });
  });
  useEffect(() => {
    reaction(
      () => {
        const changedValues = {};
        Object.entries(newValues).forEach(([key, value]) => {
          if (value !== previousValues.current[key]) {
            changedValues[key] = value;
          }
        });
        return changedValues;
      },
      (newProps) => {
        Object.assign(previousValues.current, newProps);
        callback(newProps);
      }
    );
  }, []);
}
export {
  usePropReaction
};
